import { RemoteToolsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const toolsService = new RemoteToolsService(httpClient)
